import { FormikProps } from "formik";
import CustomTextArea from "../../../../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../../../../components/Flex";
import StyledButtonV2 from "../../../../../../../../../../../../components/app/StyledButtonV2";
import StyledFormModal from "../../../../../../../../../../../../components/globalModal/StyledModal";
import { DisclosureHost } from "../../../../../../../../../../../../hooks/use-disclosure";
import useFormDraft from "../../../../../../../../../../../../hooks/use-form-draft";
import { Form2Payload } from "../../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import CheckboxCardSections from "../../InitialPsychotherapy/CheckboxCardSections";
import {
  OTHER_INTERVENTIONS,
  OTHER_INTERVENTIONS_NOTE_KEY,
  PROGRESS_INTERVENTIONS_FIELDS,
  PROGRESS_INTERVENTIONS_SECTIONS,
} from "../ProgressNoteConstant";

interface InterventionsUsedModalProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<Form2Payload>;
}

/**
 * Interventions Used — same checkbox-card flow as the DAP note's Interventions
 * Provided, with "Other Interventions" revealing a free-text field.
 */
const InterventionsUsedModal = ({
  disclosureHost,
  formik,
}: InterventionsUsedModalProps) => {
  // Edits stay in the draft until Save, so the note behind the modal is
  // untouched while the user is still filling it in.
  const draft = useFormDraft(
    formik,
    PROGRESS_INTERVENTIONS_FIELDS,
    disclosureHost.opened
  );

  const selected = (draft.values?.interventionsUsed ?? "")
    .split(",")
    .filter(Boolean);

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle="Interventions Used"
      dialogAction={
        <>
          <StyledButtonV2
            label="Cancel"
            variant="outlined"
            onClick={() => disclosureHost.close()}
          />
          <StyledButtonV2
            label="Save"
            variant="contained"
            onClick={() => {
              draft.save();
              disclosureHost.close();
            }}
            sx={{ width: "105px" }}
          />
        </>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "60vw",
          height: "70vh",
        },
      }}
    >
      <Flex flexDirection="column" gap={2} width="100%" height="100%" pt={2}>
        <CheckboxCardSections
          formik={draft}
          sections={PROGRESS_INTERVENTIONS_SECTIONS}
        />

        {selected.includes(OTHER_INTERVENTIONS) && (
          <CustomTextArea
            label="Other Interventions"
            name={OTHER_INTERVENTIONS_NOTE_KEY}
            placeholder="Describe the other interventions used..."
            value={draft.values?.otherInterventionsNote || ""}
            onChange={draft.handleChange}
            minRows={3}
          />
        )}
      </Flex>
    </StyledFormModal>
  );
};

export default InterventionsUsedModal;
